/**
* 供货管理 供货发票管理 开票记录
*/
<template>
  <div class="contianer">
    <!-- 订单提现 -->
    <div class="mt20">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="我供货的" name="first">
          <el-form :inline="true" :model="formInline" class="user-search">
            <el-form-item label="">
              <el-date-picker
                v-model="searchDate"
                type="monthrange"
                range-separator="至"
                start-placeholder="账单开始月份"
                end-placeholder="账单结束月份">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="">
              <el-input size="small" v-model="formInline.seller_purchaser_name" clearable
                        placeholder="请选择商家/发票抬头名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="search">查询</el-button>
            </el-form-item>
          </el-form>
          <!--列表-->
          <div style="height: 550px;overflow-y: auto">
            <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                      element-loading-text="拼命加载中" style="width: 100%;">
              <el-table-column align="center" type="selection" width="80">
              </el-table-column>
              <el-table-column
                label="序号"
                width="60">
                <template slot-scope="scope">
                  {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
                </template>
              </el-table-column>
              <el-table-column prop="create_time" label="申请时间" width="150">
              </el-table-column>
              <el-table-column prop="apply_no" label="发票申请单号" min-width="160" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="invoice_maker" label="开票方" width="180" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="withdraw_code" label="单据号" width="180" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="invoice_title" label="发票抬头" width="180" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="invoicable_money" label="发票金额（元）" width="120" :show-overflow-tooltip='true'>
                <template slot-scope="scope">
                  <div>￥{{scope.row.invoicable_money}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="invoice_type" label="发票类型" width="180">
                <template slot-scope="scope">
                  <div v-if="scope.row.invoice_type=='182'">增值税专用发票</div>
                  <div v-else-if="scope.row.invoice_type=='181'">增值税电子发票</div>
                  <div v-else-if="scope.row.invoice_type=='180'">增值税普通发票</div>
                  <div v-else-if="scope.row.invoice_type=='183'">全电发票(专用发票)</div>
                  <div v-else-if="scope.row.invoice_type=='184'">全电发票(普通发票)</div>
                </template>
              </el-table-column>
              <el-table-column prop="invoice_status" label="开票状态" width="100">
                <template slot-scope="scope">
                  <div plain style="color: #E6A23C" v-if="scope.row.invoice_status=='1653'">
                    开票中
                  </div>
                  <div plain style="color: #F56C6C" v-else-if="scope.row.invoice_status=='1650'">
                    待开票
                  </div>
                  <div plain style="color: #409eff" v-else>
                    已开票
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="left" label="操作" width="134">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" v-if="scope.row.invoice_ele_url"
                             @click="downloadInvoice(scope.row.invoice_ele_url)">
                    下载
                  </el-button>
                  <el-button type="text" size="mini"
                             @click="detailApply(scope.row.id,scope.row.apply_no,scope.row.delivery_no,scope.row.delivery_name)">
                    查看详情
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </el-tab-pane>

        <!-- 给我供货 -->
        <el-tab-pane label="给我供货" name="second" v-if="agent_type=='2891'">
          <el-form :inline="true" :model="formInline1" class="user-search">
            <el-form-item label="">
              <el-date-picker
                v-model="searchDate1"
                type="monthrange"
                range-separator="至"
                start-placeholder="账单开始月份"
                end-placeholder="账单结束月份">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="">
              <el-input size="small" v-model="formInline1.seller_supplier_name" clearable
                        placeholder="请选择供应商/开票方名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="search1">查询</el-button>
            </el-form-item>
          </el-form>
          <!--列表-->
          <div style="height: 550px;overflow-y: auto">
            <el-table size="small" :data="listData1" highlight-current-row v-loading="loading" border
                      element-loading-text="拼命加载中" style="width: 100%;">
              <el-table-column align="center" type="selection" width="80">
              </el-table-column>
              <el-table-column
                label="序号"
                width="60">
                <template slot-scope="scope">
                  {{pageparm1.pageSize * (pageparm1.currentPage - 1) + (scope.$index + 1)}}
                </template>
              </el-table-column>
              <el-table-column prop="create_time" label="申请时间" width="150">
              </el-table-column>
              <el-table-column prop="apply_no" label="发票申请单号" min-width="160" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="invoice_maker" label="开票方" width="180" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="withdraw_code" label="单据号" width="180" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="invoice_title" label="发票抬头" width="180" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="invoicable_money" label="发票金额（元）" width="120" :show-overflow-tooltip='true'>
                <template slot-scope="scope">
                  <div>￥{{scope.row.invoicable_money}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="invoice_type" label="发票类型" width="180">
                <template slot-scope="scope">
                  <div v-if="scope.row.invoice_type=='182'">增值税专用发票</div>
                  <div v-else-if="scope.row.invoice_type=='181'">增值税电子发票</div>
                  <div v-else-if="scope.row.invoice_type=='180'">增值税普通发票</div>
                  <div v-else-if="scope.row.invoice_type=='183'">全电发票(专用发票)</div>
                  <div v-else-if="scope.row.invoice_type=='184'">全电发票(普通发票)</div>
                </template>
              </el-table-column>
              <el-table-column prop="invoice_status" label="开票状态" width="100">
                <template slot-scope="scope">
                  <div plain style="color: #E6A23C" v-if="scope.row.invoice_status=='1653'">
                    开票中
                  </div>
                  <div plain style="color: #F56C6C" v-else-if="scope.row.invoice_status=='1650'">
                    待开票
                  </div>
                  <div plain style="color: #409eff" v-else>
                    已开票
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="left" label="操作" width="134">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" v-if="scope.row.invoice_ele_url"
                             @click="downloadInvoice(scope.row.invoice_ele_url)">
                    下载
                  </el-button>
                  <el-button type="text" size="mini"
                             @click="medetailApply(scope.row.id,scope.row.apply_no,scope.row.delivery_no,scope.row.delivery_name)">
                    查看详情
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <Pagination v-bind:child-msg="pageparm1" @callFather="callFather1"></Pagination>
        </el-tab-pane>
      </el-tabs>

      <!-- 我供货的-开票详情 -->
      <el-dialog title="开票详情" :visible.sync="supplyVisible" width="50%" center>
        <div style="display: flex; margin: 30px 0 20px 0;">
          <h2 style="font-size: 16px; margin-right: 20px; font-width: 700; line-height: 0;">开票进度</h2>
          <el-button v-if="invoiceInfo.invoice_ele_url" size="mini" type="primary" plain
                     @click="downloadInvoice(invoiceInfo.invoice_ele_url)">下载发票
          </el-button>
          <el-popover
            placement="right"
            width="522"
            trigger="click">
            <div class="sticstitle">
              物流跟踪
            </div>
            <div class="trackbox">
              <div class="logistics" v-for="(item, index) in supplyData" :ref="index">
                <div style="display: flex">
                  <div style="width: 50px;">
                    {{ item.deliver_comp }}
                  </div>
                  <div class="sticstion">
                    {{ item.deliver_tion }}
                  </div>
                </div>
                <div style="width: 135px;">
                  {{ item.deliver_time }}
                </div>
              </div>
            </div>
            <el-button size="mini" type="primary" plain slot="reference" @click="lookDelivery()">查看物流信息
            </el-button>
          </el-popover>
        </div>
        <el-steps class="logs" :active="logsLength" finish-status="success" align-center>
          <el-step :title="log.content" :description="log.create_time" v-for="log in logs" :key="log.content"></el-step>
        </el-steps>
        <template>
          <div style="display: flex; margin: 30px 0 20px 0;">
            <h2 style="font-size: 16px; margin-right: 20px; font-width: 700; line-height: 0;">开票金额</h2>
            <el-button size="mini" type="primary" plain @click="exportFile()">导出明细</el-button>
          </div>
          <div style="width: 100%; height: 160px;overflow-y: auto;">
            <el-table size="small" :data="amountData"
                      highlight-current-row v-loading="loading" show-summary :summary-method="getSummaries"
                      element-loading-text="拼命加载中" style="width: 100%;">
              <el-table-column
                label="序号"
                width="60">
                <template slot-scope="scope">
                  {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
                </template>
              </el-table-column>
              <el-table-column prop="create_time" label="账单月份" width="120">
              </el-table-column>
              <el-table-column prop="withdraw_code" label="单据号" min-width="160">
              </el-table-column>
              <el-table-column prop="fee" label="服务费金额" width="120">
                <template slot-scope="scope">
                  <div>￥{{scope.row.fee}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="invoicable_money" label="可开金额" width="160">
                <template slot-scope="scope">
                  <div>￥{{scope.row.invoicable_money}}</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </template>

        <div style="margin-top: 30px">
          <el-descriptions title="发票抬头信息" :column="2" border>
            <el-descriptions-item label="发票抬头" label-class-name="my-label">
              {{invoiceInfo.invoice_title}}
            </el-descriptions-item>
            <el-descriptions-item label="纳税识别号" label-class-name="my-label">
              {{invoiceInfo.taxpayer_no}}
            </el-descriptions-item>
            <el-descriptions-item label="开户银行" label-class-name="my-label">
              {{invoiceInfo.bank_name}}
            </el-descriptions-item>
            <el-descriptions-item label="开户银行账号" label-class-name="my-label">
              {{invoiceInfo.bank_account}}
            </el-descriptions-item>
            <el-descriptions-item label="注册地址" label-class-name="my-label">
              {{invoiceInfo.enterprise_address}}
            </el-descriptions-item>
            <el-descriptions-item label="注册电话" label-class-name="my-label">
              {{invoiceInfo.enterprise_tel}}
            </el-descriptions-item>
            <el-descriptions-item label="发票内容" label-class-name="my-label">
              {{invoiceInfo.invoice_detail}}
            </el-descriptions-item>
            <el-descriptions-item label="电子邮箱" label-class-name="my-label">
              {{invoiceInfo.invoice_email}}
            </el-descriptions-item>
          </el-descriptions>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="supplyVisible=false">取 消</el-button>
          <el-button size="small" type="primary" :loading="loading" class="title"
                     @click="supplyVisible=false">确 认
          </el-button>
        </div>
      </el-dialog>

      <!-- 给我供货-开票详情 -->
      <el-dialog title="开票详情" :visible.sync="supplyMeVisible" width="50%" center>
        <div style="display: flex; margin: 30px 0 20px 0;">
          <h2 style="font-size: 16px; margin-right: 20px; font-width: 700; line-height: 0;">开票进度</h2>
          <el-button v-if="meinvoiceInfo.invoice_ele_url" size="mini" type="primary" plain
                     @click="downloadInvoice(meinvoiceInfo.invoice_ele_url)">下载发票
          </el-button>
          <el-popover
            placement="right"
            width="522"
            trigger="click">
            <div class="sticstitle">
              物流跟踪
            </div>
            <div class="trackbox">
              <div class="logistics" v-for="(item, index) in supplymeData" :ref="index">
                <div style="display: flex">
                  <div style="width: 50px;">
                    {{ item.deliver_comp }}
                  </div>
                  <div class="sticstion">
                    {{ item.deliver_tion }}
                  </div>
                </div>
                <div style="width: 135px;">
                  {{ item.deliver_time }}
                </div>
              </div>
            </div>
            <el-button size="mini" type="primary" plain slot="reference" @click="lookDelivery1()">查看物流信息
            </el-button>
          </el-popover>
        </div>
        <el-steps class="logs" :active="melogsLength" finish-status="success" align-center>
          <el-step :title="log.content" :description="log.create_time" v-for="log in melogs" :key="log.content"></el-step>
        </el-steps>
        <template>
          <div style="display: flex; margin: 30px 0 20px 0;">
            <h2 style="font-size: 16px; margin-right: 20px; font-width: 700; line-height: 0;">开票金额</h2>
            <el-button size="mini" type="primary" plain @click="exportFile()">导出明细</el-button>
          </div>
          <div style="width: 100%; height: 160px;overflow-y: auto;">
            <el-table size="small" :data="amountData"
                      highlight-current-row v-loading="loading" show-summary :summary-method="getSummaries"
                      element-loading-text="拼命加载中" style="width: 100%;">
              <el-table-column
                label="序号"
                width="60">
                <template slot-scope="scope">
                  {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
                </template>
              </el-table-column>
              <el-table-column prop="create_time" label="账单月份" width="120">
              </el-table-column>
              <el-table-column prop="withdraw_code" label="单据号" min-width="160">
              </el-table-column>
              <el-table-column prop="fee" label="服务费金额" width="120">
                <template slot-scope="scope">
                  <div>￥{{scope.row.fee}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="invoicable_money" label="可开金额" width="160">
                <template slot-scope="scope">
                  <div>￥{{scope.row.invoicable_money}}</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </template>

        <div style="margin-top: 30px">
          <el-descriptions title="发票抬头信息" :column="2" border>
            <el-descriptions-item label="发票抬头" label-class-name="my-label">
              {{meinvoiceInfo.invoice_title}}
            </el-descriptions-item>
            <el-descriptions-item label="纳税识别号" label-class-name="my-label">
              {{meinvoiceInfo.taxpayer_no}}
            </el-descriptions-item>
            <el-descriptions-item label="开户银行" label-class-name="my-label">
              {{meinvoiceInfo.bank_name}}
            </el-descriptions-item>
            <el-descriptions-item label="开户银行账号" label-class-name="my-label">
              {{meinvoiceInfo.bank_account}}
            </el-descriptions-item>
            <el-descriptions-item label="注册地址" label-class-name="my-label">
              {{meinvoiceInfo.enterprise_address}}
            </el-descriptions-item>
            <el-descriptions-item label="注册电话" label-class-name="my-label">
              {{meinvoiceInfo.enterprise_tel}}
            </el-descriptions-item>
            <el-descriptions-item label="发票内容" label-class-name="my-label">
              {{meinvoiceInfo.invoice_detail}}
            </el-descriptions-item>
            <el-descriptions-item label="电子邮箱" label-class-name="my-label">
              {{meinvoiceInfo.invoice_email}}
            </el-descriptions-item>
          </el-descriptions>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="supplyMeVisible=false">取 消</el-button>
          <el-button size="small" type="primary" :loading="loading" class="title"
                     @click="supplyMeVisible=false">确 认
          </el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  deliveryLog, applyDetail, applyExport, applyList
} from '../../api/basisMG'
import Pagination from '../../components/Pagination'
import {timestampToDate} from "../../utils/util";

export default {
  data: () => {
    return {
      loading: false, // 是显示加载
      supplyVisible: false,
      supplyMeVisible: false,
      searchDate: '',
      searchDate1: '',
      formInline: {
        page: 1,
        rows: 10,
        begin_time: '',
        end_time: '',
        audit_status: '',
        seller_purchaser_name: ''
      },
      formInline1: {
        page: 1,
        rows: 10,
        begin_time: '',
        end_time: '',
        audit_status: '',
        seller_supplier_name: ''
      },
      tokenId: '',
      activeName: 'first',
      listData: [], //用户数据
      listData1: [], //用户数据
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页的数据条数
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      pageparm1: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      // rules表单验证
      rules: {
        seller_purchaser_id: [{required: true, message: '请选择商家名称', trigger: 'blur'}],
        seller_name: [{required: true, message: '请输入店铺名称', trigger: 'blur'}],
        agentType: [{required: true, message: '请选择供货身份', trigger: 'blur'}]
      },
      agent_type: localStorage.getItem('agent_type')||'2891',
      invoiceInfo: {},
      meinvoiceInfo: {},
      delivery_company_name: '',
      amountData: [],
      logs: [],
      logsLength: 3,
      melogs: [],
      melogsLength: 3,
      delivery_no: '',
      deliveryData: [],
      medeliveryData: [],
      delivery_name: '',
      applyId: '',
      apply_no: '',
      supplyData: [
        {
          deliver_comp: '顺丰陆运',
          deliver_tion: '[长沙市]您的快件已签收，如有疑问请电联快递员【陈旺，电话：19176697183】，感谢您使用顺丰，期待再次为您服务。（主单总件数：1件）',
          deliver_time: '2023-05-17 09:40:30'
        },
        {
          deliver_comp: '顺丰陆运',
          deliver_tion: '[长沙市]快件到达 【长沙芙蓉留园路营业点】',
          deliver_time: '2023-05-17 09:40:30'
        }
      ],
      supplymeData: [
        {
          deliver_comp: '顺丰陆运',
          deliver_tion: '[长沙市]您的快件已签收，如有疑问请电联快递员【陈旺，电话：19176697183】，感谢您使用顺丰，期待再次为您服务。（主单总件数：1件）',
          deliver_time: '2023-05-17 09:40:30'
        },
        {
          deliver_comp: '顺丰陆运',
          deliver_tion: '[长沙市]快件到达 【长沙芙蓉留园路营业点】',
          deliver_time: '2023-05-17 09:40:30'
        }
      ]
    };
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getData(this.formInline)
    this.getData1(this.formInline1)
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表1-0
    getData() {
      this.loading = true
      applyList(this.formInline)
        .then(res => {
          this.loading = false
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.content.rows
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.rows
            this.pageparm.total = res.content.total
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('网络错误，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.rows = parm.pageSize
      this.getData(this.formInline)
    },
    // 获取公司列表1-1
    getData1() {
      this.loading = true
      applyList(this.formInline1)
        .then(res => {
          this.loading = false
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData1 = res.content.rows
            // 分页赋值
            this.pageparm1.currentPage = this.formInline1.page
            this.pageparm1.pageSize = this.formInline1.rows
            this.pageparm1.total = res.content.total
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('网络错误，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather1(parm) {
      this.formInline1.page = parm.currentPage
      this.formInline1.rows = parm.pageSize
      this.getData1(this.formInline1)
    },
    // 搜索事件
    search() {
      if (this.searchDate) {
        this.formInline.begin_time = timestampToDate(this.searchDate[0])
        this.formInline.end_time = timestampToDate(this.searchDate[1])
      } else {
        this.formInline.begin_time = ''
        this.formInline.end_time = ''
      }
      this.formInline.page = 1;
      this.getData(this.formInline)
    },
    search1() {
      if (this.searchDate1) {
        this.formInline1.begin_time = timestampToDate(this.searchDate1[0])
        this.formInline1.end_time = timestampToDate(this.searchDate1[1])
      } else {
        this.formInline1.begin_time = ''
        this.formInline1.end_time = ''
      }
      this.formInline1.page = 1;
      this.getData1(this.formInline1)
    },
    // 我供货的-查看详情
    detailApply: function (id, apply_no, delivery_no, delivery_name) {
      this.applyId = id;
      this.apply_no = apply_no;
      this.delivery_no = delivery_no;
      this.delivery_name = delivery_name
      this.supplyVisible = true
      this.loading = true
      applyDetail(id)
        .then(res => {
          this.loading = false
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            if (res.content) {
              this.invoiceInfo = res.content.invoiceInfo;
              this.amountData = res.content.invoiceRecords;
              this.logs = res.content.logs;
              this.logsLength = res.content.logs.length;
              if (res.content.logs.length == 2) {
                let log2 = {
                  content: "开票完成",
                  create_time: "等待开票完成"
                }
                this.logs = res.content.logs;
                this.logs.push(log2)
              } else if (res.content.logs.length == 1) {
                let log1 = {
                  content: "财务开票",
                  create_time: "等待开票"
                }
                let log2 = {
                  content: "开票完成",
                  create_time: "等待开票完成"
                }
                this.logs = res.content.logs;
                this.logs.push(log1)
                this.logs.push(log2)
              } else {
                this.logs = res.content.logs;
              }
            }
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('网络错误，请稍后再试！')
        })
    },
    // 给我供货-开票详情
    medetailApply: function (id, apply_no, delivery_no, delivery_name) {
      this.applyId = id;
      this.apply_no = apply_no;
      this.delivery_no = delivery_no;
      this.delivery_name = delivery_name
      this.supplyMeVisible = true
      this.loading = true
      applyDetail(id)
        .then(res => {
          this.loading = false
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            if (res.content) {
              this.meinvoiceInfo = res.content.invoiceInfo;
              this.amountData = res.content.invoiceRecords;
              this.melogs = res.content.logs;
              this.melogsLength = res.content.logs.length;
              if (res.content.logs.length == 2) {
                let log2 = {
                  content: "开票完成",
                  create_time: "等待开票完成"
                }
                this.melogs = res.content.logs;
                this.melogs.push(log2)
              } else if (res.content.logs.length == 1) {
                let log1 = {
                  content: "财务开票",
                  create_time: "等待开票"
                }
                let log2 = {
                  content: "开票完成",
                  create_time: "等待开票完成"
                }
                this.melogs = res.content.logs;
                this.melogs.push(log1)
                this.melogs.push(log2)
              } else {
                this.melogs = res.content.logs;
              }
            }
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('网络错误，请稍后再试！')
        })
    },
    // 我供货的-查看物流信息
    lookDelivery() {
      deliveryLog(this.delivery_no)
        .then(res => {
          this.loading = false
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            if (res.content) {
              this.delivery_company_name = res.content.delivery_company_name;
              this.delivery_no = res.content.delivery_no;
              this.medeliveryData = res.content.logs
            }
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('网络错误，请稍后再试！')
        })
    },
    // 给我供货-查看物流信息
    lookDelivery1() {
      deliveryLog(this.delivery_no)
        .then(res => {
          this.loading = false
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            if (res.content) {
              this.delivery_company_name = res.content.delivery_company_name;
              this.delivery_no = res.content.delivery_no;
              this.medeliveryData = res.content.logs
            }
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('网络错误，请稍后再试！')
        })
    },
    // 下载发票
    downloadInvoice(url) {
      if (url) {
        if (url.indexOf('.pdf') > -1) {
          const a = document.createElement('a');
          a.style.display = 'none';
          a.setAttribute('target', '_blank');
          a.setAttribute('download', '电子发票');
          a.href = url;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        } else {
          window.location.href = url
        }
      } else {
        this.$message({
          type: 'info',
          message: '暂无电子发票'
        })
      }
    },
    // 导出明细
    exportFile() {
      this.loading = true;
      applyExport(this.applyId)
        .then(res => {
          this.loading = false
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            let url = window.URL.createObjectURL(new Blob([res]))
            // 插入一个a标签，隐藏，设置href属性，触发点击方法
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url;
            link.setAttribute('download', '开票账单明细-' + this.apply_no + '.xlsx')
            document.body.appendChild(link)
            link.click()
            //下载完成后
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('网络错误，请稍后再试！')
        })
    },
    // 合计
    getSummaries(param) {
      const {columns, data} = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总价';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = '￥' + sums[index].toFixed(2);
        } else {
          sums[index] = '-';
        }
      });

      return sums;
    },
    handleClick(tab, event) {
      console.log(tab.index)
      if (tab.index == 0) {
        this.getData(this.formInline)
      } else if (tab.index == 1) {
        this.getData1(this.formInline1)
      }
    },
  }
};
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  /deep/ .textarea .el-textarea__inner {
    height: 120px;
    width: 320px;
    resize: none;
  }

  .mt20 {
    margin-top: 20px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  /deep/ .logs .el-icon-check:before {
    color: #67C23A;
  }

  /deep/ .el-descriptions .is-bordered .el-descriptions-item__cell {
    border: 0 !important;
    border-bottom: 1px solid #F5F7FA !important;
    width: 360px;
  }

  /deep/ .my-label {
    width: 120px !important;
    background: #EBEEF5;
  }

  .sticstitle {
    font-size: 18px;
    font-weight: 700;
    line-height: 50px;
    text-align: center;
  }

  .trackbox {
    max-height: 200px;
    overflow: auto;
  }

  .logistics {
    font-size: 12px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }

  .sticstion {
    width: 307px;
    margin: 0 10px 0 20px;
    display: -webkit-box;
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }
</style>



// WEBPACK FOOTER //
// src/views/supply/supplyRecords.vue